<template>
    <form @submit.stop.prevent="handleSubmit" novalidate>
        <div class="card-body">
            <div class="form-group d-flex align-items-center">
                <div class="flex-shrink-0">
                    <img :src="form.profile_picture" class="profile-avatar rounded-circle mr-3" alt="Profile picture">
                </div>
                <div class="flex-grow-1 min-w-0">
                    <div class="small text-muted mb-2">Change profile picture</div>
                    <photo-source-picker
                        capture="user"
                        camera-label="Take selfie"
                        gallery-label="Choose photo"
                        @selected="handleFileObject"
                    />
                </div>
            </div>
            <hr>
            <div class="form-group">
                <label>Email</label>
                <input type="text" v-model="form.email" class="form-control disabled" disabled>
            </div>
            <div class="form-group">
                <label for="profile-name">Full name</label>
                <input id="profile-name" type="text" autocomplete="name" v-model="form.name" class="form-control" placeholder="Please enter fullname" :class="{ 'is-invalid' : $v.form.name.$error }">
            </div>
            <div class="form-group">
                <label for="profile-phone">Phone Number</label>
                <input id="profile-phone" type="tel" inputmode="tel" autocomplete="tel" v-model="form.phone" class="form-control" placeholder="e.g. 012-345 6789">
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <a @click="loadProfile" class="btn btn-outline-secondary btn-form mr-2">Cancel</a>
            <button type="submit" class="btn btn-primary btn-form px-">Save Changes</button>
        </div>
    </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
    data(){
        return this.initData();
    },
    mounted() {
        this.loadProfile();
    },
    validations: {
        form: {
            name: { required },
            email: { required },
        }
    },
    methods: {
        initData(){
            return {
                form:{
                    name: null,
                    email: null
                },
                file: '',
            }
        },
        async loadProfile(){
            try {
                const { data } = await axios.get(route("auth.profile.show"));
                this.form = data.data;
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        handleSubmit(bvModalEvt){
            bvModalEvt.preventDefault();
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.submitSave();
        },
        handleFileObject(file){
            this.file = file;
            this.form.profile_picture = URL.createObjectURL(this.file);
        },
        async submitSave(){
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('form', JSON.stringify(this.form));

            try {
                const { data } = await axios.post(route("auth.profile.update"), formData);
                this.$swal('Saved!', '', 'success');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
    }
}

</script>

<style scoped>
.profile-avatar {
    width: 96px;
    height: 96px;
    object-fit: cover;
}

.min-w-0 {
    min-width: 0;
}

@media (min-width: 768px) {
    .profile-avatar {
        width: 150px;
        height: 150px;
    }
}
</style>
